export const monitoringTreeConstants = {
    GET_MONITORING_TREE_SUCCESS: 'GET_MONITORING_TREE_SUCCESS',
    GET_MONITORING_TREE_FAILURE: 'GET_MONITORING_TREE_FAILURE',

    UPDATE_MONITORING_TREE_SUCCESS: 'UPDATE_MONITORING_TREE_SUCCESS',
    UPDATE_LOCAL_MONITORING_TREE_SUCCESS: 'UPDATE_LOCAL_MONITORING_TREE_SUCCESS',
    UPDATE_MONITORING_TREE_FAILURE: 'UPDATE_MONITORING_TREE_FAILURE',

    GET_MONITORING_TREES_PART_SUCCESS: 'GET_MONITORING_TREES_PART_SUCCESS',
};